import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const actions = {
    getDashboardApplications: {
        method: 'GET',
        url: `${BASE_PATH_API}/dashboard/applications/:applicationStatusId`
    },
    getRentalApplicationStates: {
        method: 'GET',
        url: `${BASE_PATH_API}/dashboard/applications/states`
    },
    getApplicationAwatStatuses: {
        method: 'GET',
        url: `${BASE_PATH_API}/dashboard/applications/awat`
    },
    getOutstandingBalances: {
        method: 'GET',
        url: `${BASE_PATH_API}/dashboard/outstandingBalances/:propertyType`
    },
    getOutstandingBills: {
        method: 'GET',
        url: `${BASE_PATH_API}/dashboard/outstandingBills`
    },
    getUndepositedFunds: {
        method: 'GET',
        url: `${BASE_PATH_API}/dashboard/undepositedFunds`
    },
    getIncomingRequests: {
        method: 'GET',
        url: `${BASE_PATH_API}/dashboard/incomingRequests`
    },
    getAssignedTasks: {
        method: 'GET',
        url: `${BASE_PATH_API}/dashboard/assignedTasks`
    },
    getTaskStates: {
        method: 'GET',
        url: `${BASE_PATH_API}/dashboard/tasks/states`
    },
    getRentalListings: {
        method: 'GET',
        url: `${BASE_PATH_API}/dashboard/listings`
    },
    getExpiringLeases: {
        method: 'GET',
        url: `${BASE_PATH_API}/dashboard/expiringLeases`
    },
    saveDashboardSettings: {
        method: 'PUT',
        url: `${BASE_PATH_API}/dashboard/settings`
    },
    getDashboardSettings: {
        method: 'GET',
        url: `${BASE_PATH_API}/dashboard/settings`
    },
    getRentersInsurance: {
        method: 'GET',
        url: `${BASE_PATH_API}/dashboard/rentersInsuranceCounts`
    },
    getExpiringRentersInsurance: {
        method: 'GET',
        url: `${BASE_PATH_API}/dashboard/rentersInsuranceExpiration`
    },
    getLeasesLiabilities: {
        method: 'GET',
        url: `${BASE_PATH_API}/dashboard/leasesLiabilities`,
        transformResponse: function transformResponse(response, headers) {
            const totalCount = headers.get('X-Total-Count');
            return totalCount === null
                ? null
                : {
                    Data: response,
                    TotalCount: totalCount
                };
        }
    },
    getPendingApprovalBills: {
        method: 'GET',
        url: `${BASE_PATH_API}/dashboard/pendingApprovalRequests?$top=6`,
        transformResponse: function transformResponse(response, headers) {
            const totalCount = headers.get('X-Total-Count');
            return totalCount === null
                ? null
                : {
                    Data: response,
                    TotalCount: totalCount
                };
        }
    }
};

export function DashboardApi() {
    return createActions(actions);
}
